<template>
  <DashboardTemplate>
    <div id="community">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          :to="{ path: '/' }"
          class="text-over clamp1 hidden-sm-and-down"
          >หน้าแรก</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/project/1' }"
          class="text-over clamp1"
          >โครงการทุนวัฒนธรรมชุมชนสู่หัตถกรรมล้านนาสร้างสรรค์</el-breadcrumb-item
        >
        <el-breadcrumb-item class="text-over clamp1">{{
          community.name
        }}</el-breadcrumb-item>
      </el-breadcrumb>
      <h2>{{ community.title }}</h2>
      <div v-if="community.description" class="detail">
        <p class="indent">
          {{ community.description }}
        </p>
        <el-row :gutter="40">
          <el-col
            v-for="item in community.result"
            :key="item.id"
            :xs="24"
            :sm="12"
          >
            <div
              @click="$router.replace(`/product/${item.id}`)"
              class="card-product"
            >
              <el-image :src="item.image" fit="cover" />
              <p>{{ item.description }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else class="detail">
        <p>*** ไม่มีข้อมูล ***</p>
      </div>
    </div>
  </DashboardTemplate>
</template>


<script>
import DashboardTemplate from "@/template/DashboardTemplate.vue";

export default {
  components: {
    DashboardTemplate,
  },

  computed: {
    community() {
      let community = this.communies.find((f) => f.id == this.$route.params.id);
      return typeof community !== "undefined" ? community : null;
    },
  },
  created() {
    window.scrollTo(0, 0);
  },
  data() {
    return {
      communies: [
        {
          id: 1,
          name: "ศูนย์วัฒนธรรมไทลื้อวัดหย่วน ตำบลหย่วน อำเภอเชียงคำ จังหวัดพะเยา",
          title:
            "การพัฒนาศักยภาพผู้ประกอบการชุมชนไทลื้อวัดหย่วนในการพัฒนาผลิตภัณฑ์ด้วยกระบวนการคิดเชิงออกแบบ Design Thinking และผลิตภัณฑ์ที่ได้จากการเข้าร่วมโครงการฯ",
          description:
            "การพัฒนาศักยภาพผู้ประกอบการชุมชนไทลื้อวัดหย่วน ต.หย่วน อ.เชียงคำ จ.พะเยา ดำเนินการโดยจัดกระบวนการฝึกอบรมเชิงปฏิบัติการในด้านการพัฒนาผลิตภัณฑ์ด้วยกระบวนการคิดเชิงออกแบบ Design Thinking เป็นกระบวนการหลักในการฝึกอบรมเชิงปฏิบัติการเพื่อให้ผู้เข้าร่วมสามารถพัฒนาผลิตภัณฑ์ หรือ Prototype ให้ตรงกับกลุ่มผู้ซื้อหรือผู้ใช้เป็นหลัก ผ่านการทำการวิจัยหรือสำรวจอย่างง่าย ไปพร้อม ๆ กับการฝึกทักษะในด้านอื่น ๆ ที่เกี่ยวข้อง และมีความจำเป็นต่อการเป็นผู้ประกอบการสมัยใหม่ อาทิเช่น การวางแผนธุรกิจ คิดต้นทุน การทำการตลาด การทำประชาสัมพันธ์กับสื่อออนไลน์ การฝึกทักษะในการถ่ายภาพ ถ่ายคลิป ตัดต่อคลิป และการรู้สร้างอัตลักษณ์ของผลิตภัณฑ์ชุมชนให้มีความโดดเด่นแตกต่างจากที่อื่น ๆ ด้วยการดึงทุนวัฒนธรรมชุมชนของตนเองมาผสานกับผลิตภัณฑ์ และสามารถบอกเล่าเรื่องราวต่าง ๆ ที่เกี่ยวกับวิถีชีวิต วัฒนธรรม ประเพณี การละเล่น ฯลฯ ที่นำมาเชื่อมโยงกับผลิตภัณฑ์ตนเองได้ โดยผลผลิตหรือผลิตภัณฑ์ที่เกิดจากการเข้าร่วมโครงการนี้ ได้แก่",
          result: [
            {
              id: "cp1",
              description: "กระเป๋าสะพายไทลื้อผ้าตาแสง",
              image: require("../assets/product/cp1-2.jpg"),
            },
            {
              id: "cp2",
              description: "ถุงย่ามยกมุกไทลื้อ",
              image: require("../assets/product/cp2-1.jpg"),
            },
            {
              id: "cp3",
              description: `โมเดลตุ๊กตาไทลื้อตั้งโต๊ะ`,
              image: require("../assets/product/cp3-1.jpg"),
            },
            {
              id: "cp4",
              description: "ถุงผ้าไทลื้อใส่แก้วเยติ",
              image: require("../assets/product/cp4-1.jpg"),
            },
            {
              id: "cp5",
              description: "หมวกผ้าฝ้ายปักลายอัตลักษณ์ไทลื้อ",
              image: require("../assets/product/cp5-1.jpg"),
            },
            {
              id: "cp6",
              description: "หมอนอิงไทลื้อ",
              image: require("../assets/product/cp6-1.jpg"),
            },
          ],
        },
        {
          id: 2,
          name: "ชุมชนแม่อิง ตำบลแม่อิง อำเภอภูกามยาว จังหวัดพะเยา",
          title:
            "เรื่องราว/เรื่องเล่าเกี่ยวกับที่มาที่ไปของการออกแบบชุดฟ้อนท์ตัวอักษรภาษาไทยและภาษาอังกฤษร่วมกับชุมชนแม่อิง",
          description: "",
          result: [],
        },
      ],
    };
  },
};
</script>


<style lang="scss" scoped>
@import "../styles/element-variables.scss";
#community {
  padding: 40px 10vw 40px 10vw;
  text-align: left;
  min-height: 20vw;

  h1 {
    font-size: 30px;
    margin: 40px 0 50px 0;
    letter-spacing: 0;
  }
  .writtenBy {
    text-align: right;
    font-style: italic;
    font-size: 14px;
  }

  h2 {
    font-size: 22px;
    margin: 40px 0 10px 0;
  }
  .detail {
    text-align: left;
    p.indent {
      text-indent: 3em;
      text-align: justify;
      word-break: break-all;
    }
    .card-product {
      padding: 10px 0;
      overflow: hidden;
      cursor: pointer;
      text-align: center;
      .el-image {
        height: 300px;
        width: 100%;
      }

      @media (max-width: 767px) {
        height: auto;
        padding: 10px 0;
      }
    }

    .card-product:hover {
      p {
        color: $--color-primary;
      }
    }
  }
}
</style>